module.exports = __webpack_public_path__ + "static/INSTALL.4858b933.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/INSTALL.pdf
// module id = 103
// module chunks = 1135276415346 35783957827783